import { render, staticRenderFns } from "./ClassStats.vue?vue&type=template&id=2cc071f9&"
import script from "./ClassStats.vue?vue&type=script&lang=js&"
export * from "./ClassStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports